import React, {Component} from 'react'
import {Button, Select,Form,Row,Col,Radio,message} from "antd";
import "./route.less"
import "./route-line.less"
import RouteEditStepForm from "./route-step-edit";
import ajax from "../../../src/api/ajax";
import {baseUrl,reqArea} from "../../../src/api";
const EditableContext = React.createContext();
const MAX_SIZE = 21;
class RouteEdit  extends Component {
    default_nodes={
        "O":[
            {
                name:"货运订单",
            },
            {
                name:"货物入场"
            },
            {
                name:"出口报关"
            },
            {
                name:"海关放行"
            },
            {
                name:"到达",
                editable:true,
            },
            {
                name:"转运",
                editable:true,
            },
            {
                name:"抵达目的地"
            },
        ],
        "I":[
            {
                name:"货运订单",
            },
            {
                name:"货物入场"
            },
            {
                name:"起运地出发"
            },
            {
                name:"到达",
                editable:true,
            },
            {
                name:"转运",
                editable:true,
            },
            {
                name:"进口报关",
            },
            {
                name:"海关放行",
            },
            {
                name:"抵达目的地",
            },
        ]
    }

    constructor(props, context) {
        super(props, context);
        this.state={
            nodes: {
                "O": [],
                "I": [],
            },
            editingIndex:-1,
            routeName:"",
            routeType:'O',
            code:"",
            readOnly:true,
            id:null,
            origin: [],
            destination: [],
            originCity:"",
            destinationCity:"",
        }
    }

    addNode=()=>{
        if(this.state.nodes[this.state.routeType].length>MAX_SIZE){
            message.error("已经达到最大数量!")
            return
        }
        let newNodes = [...this.state.nodes[this.state.routeType]]
        newNodes.splice(-1,0,{name:"请输入节点名"+(newNodes.length+1),editable:true,deletable:true})
        let nodes = Object.assign(this.state.nodes,{[this.state.routeType]:newNodes})
        this.setState({
            nodes:nodes,
        });
    }
    delNode=(index)=>{
        let newNodes = [...this.state.nodes]
        newNodes.splice(index, 1);
        this.setState({
            nodes:newNodes,
        });
    }
    saveNode=(form,index)=>{
        form.validateFields((error, value) => {
            if (error) {
                return;
            }
            let newNodes = [...this.state.nodes]
            let node = newNodes[index]
            let newNode = Object.assign(node,value)
            newNodes.splice(index, 1,{
                ...node,
                ...newNode,
            });
            this.setState({
                nodes:newNodes,
                editingIndex:"",
            });
        });
    }
    load= async (routeId) => {
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/api/v1/p/mms/kt/route", {routeId});
        if(result&&result.data){
            for(let item of this.state.origin){
                if(result.data.start === (item.countryName+item.cityName)){
                    this.setState({
                        originCity:item.cityId
                    })
                }
                if(result.data.destination === (item.countryName+item.cityName)){
                    this.setState({
                        destinationCity:item.cityId
                    })
                }
            }
            for(let item of this.state.destination){
                if(result.data.start === (item.countryName+item.cityName)){
                    this.setState({
                        originCity:item.cityId
                    })
                }
                if(result.data.destination === (item.countryName+item.cityName)){
                    this.setState({
                        destinationCity:item.cityId
                    })
                }
            }
            this.loadChilds(routeId,result.data.type)
            this.setState({
                data:result.data,
                routeType:result.data.type,
                code:result.data.code,
            })
        }else{
            message.error("线路不存在！")
        }
        this.setState({
            loading: false
        })
    }
    loadChilds = async (routeId,routeType)=>{
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/api/v1/p/mms/kt/routeNodes", {routeId});
        if(result&&result.data){
            let newd = result.data.sort((a,b)=>{
                return a.indx-b.indx
            })
            let nodes = {}
            if(routeType === "O"){
                let nodes_o = []
                let newNodes = []
                if(result.data.length>=7){
                    for (let i =4; i < newd.length-1; i++) {
                        let node = {
                            id: newd[i].id,
                            index: newd[i].indx,
                            name: newd[i].node,
                            editable: true,
                            deletable: i !==4&&i!==5,
                        }
                        nodes_o.push(node)
                    }
                    newNodes = this.default_nodes[routeType].slice(0,4).concat(nodes_o,this.default_nodes[routeType].slice(-1))
                }else{
                    newNodes = [...this.default_nodes[routeType]]
                }
                nodes["O"]=[...newNodes]
                nodes["I"]=[...this.default_nodes["I"]]
            }
            if(routeType === "I"){
                let nodes_i = []
                let newNodes = []
                if(result.data.length>=8){
                    for (let i =3; i < newd.length-1; i++) {
                        let node = {
                            id: newd[i].id,
                            index: newd[i].indx,
                            name: newd[i].node,
                            editable: i!==5&&i!==6,
                            deletable: i !==3&&i!==4&&i!==5&&i!==6,
                        }
                        nodes_i.push(node)
                    }
                    newNodes = this.default_nodes[routeType].slice(0,3).concat(nodes_i,this.default_nodes[routeType].slice(-1))
                }else{
                    newNodes = [...this.default_nodes[routeType]]
                }
                nodes["I"]=[...newNodes]
                nodes["O"]=[...this.default_nodes["O"]]
            }
            this.setState({
                nodes:nodes
            })
        }else{
            message.error("线路不存在！")
        }
        this.setState({
            loading: false
        })
    }
    init = async () => {
        await this.getCity('', 'F')
        await this.getCity('', 'T')
        if (this.props.match.params) {
            let id = this.props.match.params.id
            console.log(1,id)
            if(id) {
                this.setState({
                    id: id
                })
                this.load(id)
            }else{
                let nodes = {}
                nodes={...this.default_nodes}
                this.setState({
                    readOnly:false,
                    id:null,
                    code:null,
                    nodes:nodes,
                })
            }
        }else{
            this.setState({
                id:null,
                code:null,
            })
        }
    }
    getCity = async (cityId, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            if (type === 'F') {
                this.setState({origin: result.data});
            } else if (type === 'T') {
                this.setState({destination: result.data})
            }
        } else {
            message.error(result.message);
        }
    };
    save=()=>{
        this.props.form.validateFields((error, value) => {
            if (error) {
                return;
            }
            let start =""
            let destination = ""
            let nodeList = []
            for(let item of this.state.origin){
                if(value.originCity === (item.cityId)){
                    start = item.countryName+item.cityName
                }
                if(value.destinationCity === (item.cityId)){
                    destination = item.countryName+item.cityName
                }
            }
            for(let item of this.state.destination){
                if(value.originCity === (item.cityId)){
                    start = item.countryName+item.cityName
                }
                if(value.destinationCity === (item.cityId)){
                    destination = item.countryName+item.cityName
                }
            }
            for(let i=0;i< this.state.nodes[this.state.routeType].length;i++){
                nodeList.push({
                    indx:i+1,
                    node:this.state.nodes[this.state.routeType][i].name,
                })
            }
            let date = {
                code:this.state.code,
                start:start,
                destination:destination,
                type:this.state.routeType,
                nodeList:nodeList
            }
            this.setState({
                loading:true,
            })
            let type = this.state.code!==null?"PUT":"POST"

            let result = ajax(baseUrl+'/api/v1/p/mms/kt/route',date,type);
            result.then((resp)=> {
                if (resp.code === 200) {
                    message.info("更新成功")
                }else if(resp.code === 201){
                    message.info("保存成功")
                }else{
                    message.error(resp.message)
                    this.setState({
                    })
                }
            }).catch(()=>{

                this.setState({
                })
            }).finally(()=>{
                this.setState({
                    loading:false
                })
            })
        });
    }
    componentDidMount() {
        if(this.props.location.state){
            let {readOnly} = this.props.location.state
            this.setState({
                readOnly
            })
        }
        this.init()
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 8},
            wrapperCol: {span: 15}
        };
        const options1 = this.state.origin.map(d => <Select.Option key={d.cityId}
                                                            value={d.cityId}>{d.countryName + ' ' + d.cityName}</Select.Option>);
        const options2 = this.state.destination.map(d => <Select.Option
            key={d.cityId} value={d.cityId}>{d.countryName + ' ' + d.cityName}</Select.Option>);
        return (
            <EditableContext.Provider value={this.props.form}>
                <div className='order-info box-shadow padding-20'>
                    <Form {...formItemLayout} >
                    <Row>
                        <Col span={6}>
                            <Form.Item label="起运地">
                                {getFieldDecorator('originCity', {
                                    initialValue: this.state.originCity,
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Select style={{ marginRight: '10px'}}
                                           disabled={this.state.readOnly}
                                           getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    {this.state.routeType==="O"?options1:options2}
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="目的地">
                                {getFieldDecorator('destinationCity', {
                                    initialValue: this.state.destinationCity,
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Select style={{marginRight: '10px'}}
                                           disabled={this.state.readOnly}
                                           getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    {this.state.routeType==="O"?options2:options1}
                                </Select>)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="线路类型" {...formItemLayout}>
                                {getFieldDecorator('routeType', {
                                    rules: [
                                        {
                                            required: true,
                                            message: `请输入!`,
                                        },
                                    ],
                                    initialValue: this.state.routeType,
                                })(<Radio.Group
                                    disabled={this.state.readOnly}
                                    onChange={(e)=>{
                                    this.setState({routeType:e.target.value},()=>{
                                        let originCity = this.state.originCity
                                        let destinationCity = this.state.destinationCity
                                        this.setState({
                                            originCity:destinationCity,
                                            destinationCity:originCity,
                                        })
                                        this.props.form.setFieldsValue({
                                            originCity:destinationCity,
                                            destinationCity:originCity,
                                        })
                                    })
                                }}>
                                    <Radio value={'I'}>进口</Radio>
                                    <Radio value={'O'}>出口</Radio>
                                </Radio.Group>)}
                            </Form.Item>
                        </Col>
                        {this.state.readOnly?null:(
                            <Col span={6} style={{float:"right"}}>
                                <Button onClick={()=>{this.addNode()}} style={{marginRight: 8}} >添加节点</Button>
                                <Button onClick={()=>{this.save()}} type="primary">保存</Button>
                            </Col>
                        )}

                    </Row>

                    <RouteEditStepForm nodes={this.state.nodes} routeType={this.state.routeType} readOnly={this.state.readOnly} updateNodes={(nodes)=>{
                        this.setState({
                        nodes:nodes
                    })}}/>
                    </Form>
                </div>
            </EditableContext.Provider>
        );
    }
}
const RouteEditForm = Form.create()(RouteEdit)
export default RouteEditForm